import { MKT_DATA, DONEM_DATA, TAKIM_POS, TAKIM_NEG } from "../data/kalibrasyon";

/**
 * Rapordaki "🎯 Kalibrasyon" sekmesi.
 *
 * Öncelik: analiz sırasında GERÇEKTEN uygulanan kalibrasyonlar (backend
 * gpt_reports.kalibrasyon'a yazar). Kayıt yoksa (kalibrasyon kaydından önce
 * üretilmiş eski tahminler), o ligin GENEL kalibrasyon profilini kalibrasyon.js
 * araştırma verisinden gösterir — bilgilendirici, ama "uygulanan" değil.
 */
const ppText = (v) => {
  const n = parseFloat(String(v).replace("pp", "").replace(",", "."));
  if (isNaN(n)) return "—";
  return `${n > 0 ? "+" : n < 0 ? "−" : ""}${Math.abs(n).toFixed(1)} pp`;
};
const ppColor = (v) => {
  const n = parseFloat(String(v).replace("pp", ""));
  return isNaN(n) ? "#6b7280" : n > 0 ? "#1d5fbf" : n < 0 ? "#c0392f" : "#6b7280";
};

function Satir({ metin }) {
  return (
    <div style={{ display: "flex", gap: 8, padding: "8px 10px", borderRadius: 8,
                  background: "#f8fafc", border: "1px solid #eef2f7", fontSize: 12.5,
                  color: "#334155", lineHeight: 1.5 }}>
      <span>{metin}</span>
    </div>
  );
}

export default function KalibrasyonView({ pred }) {
  const reports = pred.gpt_reports || (pred.ai_provider === "gpt" ? pred.reports : null) || pred.reports || {};
  const recorded = (reports.kalibrasyon || "").trim();

  // ── 1) Gerçekten uygulananlar (backend kaydı) ──
  if (recorded) {
    const satirlar = recorded.split("\n").map(s => s.trim()).filter(Boolean);
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ fontSize: 12, color: "#15803d", fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{ width: 7, height: 7, borderRadius: 4, background: "#16a34a", display: "inline-block" }} />
          Bu maça uygulanan kalibrasyonlar
        </div>
        {satirlar.map((s, i) => <Satir key={i} metin={s} />)}
        <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2, lineHeight: 1.5 }}>
          Baseline'a ek olarak, 24.265 maçlık araştırmadan çıkan sistematik piyasa sapmaları
          yukarıdaki gibi uygulandı; nihai olasılıklar buna göre düzeltildi.
        </div>
      </div>
    );
  }

  // ── 2) Kayıt yoksa: ligin genel kalibrasyon profili (araştırma verisi) ──
  const lig = pred.league;
  const mkt = MKT_DATA.find(r => r.l === lig);
  const dnm = DONEM_DATA.find(r => r.l === lig);
  const takimlar = [...TAKIM_POS, ...TAKIM_NEG].filter(
    r => r.t === pred.home || r.t === pred.away
  );

  const bloklar = [];
  if (mkt) bloklar.push(
    <div key="mkt">
      <div style={{ fontSize: 11.5, fontWeight: 700, color: "#1d5fbf", marginBottom: 6 }}>📈 Piyasa Edge ({mkt.n} maç)</div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6, marginBottom: 4 }}>
        {[["Ev fav.", mkt.a], ["Deplasman", mkt.b], ["Beraberlik", mkt.c]].map(([l, v]) => (
          <div key={l} style={{ background: "#f8fafc", border: "1px solid #eef2f7", borderRadius: 7, padding: "6px 8px", textAlign: "center" }}>
            <div style={{ fontSize: 10, color: "#94a3b8" }}>{l}</div>
            <div style={{ fontSize: 13, fontWeight: 800, color: ppColor(v) }}>{ppText(v)}</div>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 11.5, color: "#64748b" }}>{mkt.sig}</div>
    </div>
  );
  if (dnm) bloklar.push(
    <div key="dnm">
      <div style={{ fontSize: 11.5, fontWeight: 700, color: "#a2542b", marginBottom: 4 }}>🧭 Dönem & Hafta İçi</div>
      <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.5 }}>
        Hafta içi ev avantajı <b style={{ color: ppColor(dnm.mw) }}>{ppText(dnm.mw)}</b>,
        sezon ortası (D3) <b style={{ color: ppColor(dnm.d[2]) }}>{ppText(dnm.d[2])}</b>. {dnm.k}
      </div>
    </div>
  );
  if (takimlar.length) bloklar.push(
    <div key="takim">
      <div style={{ fontSize: 11.5, fontWeight: 700, color: "#334155", marginBottom: 4 }}>🎯 Takım Radarı</div>
      {takimlar.map(r => (
        <div key={r.t} style={{ fontSize: 12, color: "#475569" }}>
          <b>{r.t}</b>: piyasa {parseFloat(r.e) > 0 ? "hafife alıyor" : "abartıyor"}{" "}
          <b style={{ color: ppColor(r.e) }}>{ppText(r.e)}</b> ({r.n} maç)
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ fontSize: 11.5, color: "#b45309", background: "#fffbeb", border: "1px solid #fde68a",
                    borderRadius: 8, padding: "8px 10px", lineHeight: 1.5 }}>
        Bu analizde uygulanan kalibrasyon detayı kaydedilmedi (kayıt özelliğinden önce üretildi).
        Aşağıda <b>{lig}</b> için genel kalibrasyon profili gösteriliyor; yeni analizlerde bu sekme
        maça özel uygulanan düzeltmeleri listeler.
      </div>
      {bloklar.length ? bloklar : (
        <div style={{ fontSize: 12.5, color: "#94a3b8" }}>Bu lig için kalibrasyon profili verisi yok.</div>
      )}
    </div>
  );
}
